<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="700"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'Output',
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
        }
    },
    methods:{
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
    }
}
</script>

<style>

</style>